enum MessageBusEvent {
	OrderUpdatedEvent = 'order-updated-event',
	LockboxListUpdatedEvent = 'lockbox-list-updated-event',
	InventoryUpdatedEvent = 'inventory-updated-event',
	FileUploadStateUpdated = 'file-upload-state-updated-event',
	FilesSelected = 'file-upload-selected',
	AddConditionIssue = 'add-condition-issue',
	DeleteConditionIssue = 'delete-condition-issue',
	AddRemedy = 'add-remedy',
	DeleteRemedy = 'delete-remedy',
	EscalateConditionIssue = 'escalate-condition-issue',
	RemoveFile = 'remove-file',
	AddBid = 'add-bid',
	OfflineFileUploadFailed = 'offline-file-upload-failed',
	OfflineCommandSyncingFailed = 'offline-command-syncing-failed',
	/** A booking of the signed-in user changed (SignalR `NotifyBookingChanged`); payload `BookingChangedNotificationModel`. */
	BookingChanged = 'booking-changed',
	/** Work-order's offline queues report their state for the sync indicator; payload `OfflineSyncStatus` or `null`. */
	OfflineSyncStatus = 'offline-sync-status',
	UploadLogsEvent = 'upload-logs-event'
}

export default MessageBusEvent;
